import React, { useState, useRef } from 'react'
import place from './places'

import Checkbox from '@mui/material/Checkbox';

// styles
import styles from "../AddNewFile.module.css"

export default function PlacesInput(props) {
  const [query, setQuery] = useState(props?.placeName)
  const [showLists, setShowLists] = useState(false)
  const dropdownRef = useRef(null);

  const handleBlur = () => {
    if (props.userRequest) {
      setTimeout(() => {
        if (!dropdownRef.current.contains(document.activeElement)) {
          props.setDropDownsData((prev) => {
            return { ...prev, showList: false };
          });
        }
      }, 300);
    } else {
      setTimeout(() => {
        if (!dropdownRef.current.contains(document.activeElement)) {
          setShowLists(false);
        }
      }, 300);
    }
  };

  const inputHandler = (event) => {
    var lowerCase = event.target.value.toLowerCase();
    setQuery(lowerCase);
  };

  const search = (data) => {
    return data.filter((item) => item.name.toLowerCase().includes(query));
  };

  const handleClick = (id) => {
    setTimeout(() => {
      if (!dropdownRef.current.contains(document.activeElement)) {
        const itemSelected = place.filter((item) => id === item.id);
        setQuery(itemSelected[0].name)
        props.setDropDownsData((prev) => {
          return { ...prev, place: itemSelected[0].name };
        });
        setShowLists(false);
      }
    }, 300);
  };

  return (
    <>
      <div className="py-2">
        <div className="container-fluid" style={props.filterModal && { padding: "0" }}>
          <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3" dir="rtl">
            <div className='w-100 position-relative d-flex flex-column align-items-md-start align-items-start justify-content-center flex-wrap'>
              <div className={`mb-2 ${styles.submenu_title}`}>
                منطقه
              </div>
              <input className={`pe-3 ${props.userAdd ? styles.searchbox_user : styles.searchbox}`} style={props.filterModal && { width: "300px" }} type="text" name="query" value={query} onChange={inputHandler} onFocus={props.userRequest ? () => props.setDropDownsData((prev) => {
                return { ...prev, showList: true };
              }) : () => setShowLists(!showLists)} placeholder='جستجوی منطقه (نام منطقه را بنویسید)' onBlur={handleBlur} ref={dropdownRef} />

              {!props.userRequest &&
                showLists &&
                <Lists style={props.filterModal && { width: "300px" }} list={search(place)} handleClick={handleClick} userAdd={props.userAdd ? true : false} />
              }
              {props.userRequest &&
                props.showLists &&
                <ListsRequestFile list={search(place)} handleClick={handleClick} userAdd={props.userAdd ? true : false} place={props.placeName} statusHandler={props.statusHandler} />
              }
            </div>
          </div>
        </div>
      </div>
    </>
  )

}

function Lists({ list, handleClick, userAdd, style }) {
  return (
    <>
      <div className={`d-flex flex-column align-items-start justify-content-start mt-2 py-2 px-4 ${userAdd ? styles.lists_container_user : styles.lists_container}`} style={style}>
        {list?.map((item) => (
          <div key={item.id} className={`my-2 w-100 ${styles.list_item}`} onClick={() => handleClick(item.id)}>
            {item.name}
          </div>
        ))}
      </div>
    </>
  );
}

function ListsRequestFile({ list, userAdd, place, statusHandler }) {
  return (
    <>
      <div className={`d-flex flex-column align-items-start justify-content-start mt-2 py-2 px-4 ${userAdd ? styles.lists_container_user : styles.lists_container}`} >
        {list?.map((item) => (
          <div key={item.id} className={`my-2 w-100 ${styles.list_item}`} >
            <Checkbox
              checked={place?.find(pItem => pItem === item.name) ? true : false}
              onClick={() => statusHandler(item.name)}
              inputProps={{ 'aria-label': 'controlled' }}
              size="small"
              name="heldOn"
            />
            {item.name}
          </div>
        ))}
      </div>
    </>
  );
}
